import { request } from './http'

export type CorrectionScope = 'book' | 'character' | 'style' | 'redline'
export type CorrectionStrength = 'soft' | 'hard'
export type CorrectionStatus = 'proposed' | 'confirmed' | 'discarded'

export interface CorrectionRule {
  id: string
  project_id: string
  scope: CorrectionScope | string
  tag?: string
  rule_text: string
  reason: string
  status: CorrectionStatus | string
  targets?: Record<string, unknown>
  strength: CorrectionStrength | string
  feedback_score: number
  source?: Record<string, unknown>
  created_at: string
}

export interface CreateCorrectionRuleInput {
  scope: CorrectionScope
  tag?: string
  rule_text: string
  reason?: string
  patch_id?: string
  targets?: Record<string, unknown>
  strength?: CorrectionStrength
  feedback_score?: number
  source?: Record<string, unknown>
}

interface CorrectionRulesResponse {
  rules: CorrectionRule[] | null
}

export const correctionApi = {
  list: async (projectId: string, status?: CorrectionStatus | string): Promise<CorrectionRule[]> => {
    const qs = new URLSearchParams()
    if (status) qs.set('status', status)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    const data = await request<CorrectionRulesResponse>(`/v1/projects/${encodeURIComponent(projectId)}/correction-rules${suffix}`)
    return data.rules ?? []
  },

  create: (projectId: string, body: CreateCorrectionRuleInput): Promise<CorrectionRule> =>
    request<CorrectionRule>(`/v1/projects/${encodeURIComponent(projectId)}/correction-rules`, {
      method: 'POST',
      body,
    }),

  confirm: (projectId: string, ruleId: string): Promise<CorrectionRule> =>
    request<CorrectionRule>(`/v1/projects/${encodeURIComponent(projectId)}/correction-rules/${encodeURIComponent(ruleId)}/confirm`, {
      method: 'POST',
    }),

  disable: (projectId: string, ruleId: string): Promise<CorrectionRule> =>
    request<CorrectionRule>(`/v1/projects/${encodeURIComponent(projectId)}/correction-rules/${encodeURIComponent(ruleId)}/disable`, {
      method: 'POST',
    }),
}
